// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"6fa113b5","275":"755070e8","328":"894da518","444":"dbe28781","654":"34a47360","688":"09aa365a","707":"e697c09b","856":"fca30b2c"}[chunkId] + ".chunk.js";
};